<template>
  <div>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :selection="false"
      :query="query"
      :toolbar="toolbar"
      label-width="100px"
    />
  </div>
</template>

<script>
import { HOST } from '@/utils/host'
const token = window.localStorage.getItem('token')
export default {
  data() {
    return {
      url: '/business/Log/page',
      columns: [
        {
          label: '操作菜单',
          prop: 'title'
        },
        {
          label: '操作类型',
          prop: 'businessType'
        },
        // {
        //   label: '操作描述',
        //   prop: 'description'
        // },
		{
		  label: '入参',
		  prop: 'operParam'
		},
		{
		  label: '出参',
		  prop: 'jsonResult'
		},
        {
          label: '操作者账号',
          prop: 'userName'
        },
        {
          label: 'IP',
          prop: 'ip'
        },
        {
          label: '操作时间',
          prop: 'createDate'
        }
      ],
      query: [
        {
          label: '操作菜单',
          prop: 'title',
          placeholder: '请输入操作菜单'
        },
        {
          label: '操作类型',
          prop: 'businessType',
          placeholder: '请输入操作类型'
        },
        {
          label: 'IP',
          prop: 'ip',
          placeholder: '请输入ip'
        },
        {
          label: '操作时间',
          prop: 'createDate',
          placeholder: '',
          type: 'date2'
        },
        {
          label: '操作者账号',
          prop: 'userName',
          placeholder: '请输入操作者账号'
        }
      ],
      toolbar: [
        {
          label: '导出',
          icon: 'el-icon-download',
          permission: 'logCheck.operationlog.export',
          type: 'primary',
          handle: resp => {
            const url = HOST + '/business/Log/export'
            const queryData = this.$refs.tableref.getQueryData()
            queryData.token = window.localStorage.getItem('token')
            queryData.companyId = window.localStorage.getItem('curCompanyId')
            $.fileDownload(url, {
              httpMethod: 'post',
              data: queryData,
              failCallback: (html, url) => {
                this.$notify({
                  title: '失败',
                  message: '导出失败',
                  type: 'error'
                })
              }
            })
          }
        }
      ]
    }
  },
  computed: {
    headers() {
      return {
        token: token
      }
    },
    action() {
      return HOST + '/oss'
    }
  },
  methods: {}
}
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/views/systemManagement/logOperation.vue